const context = require.context("../svg", true, /\.svg$/)

function importAll (r) {
  r.keys().forEach(r);
}

importAll(context);

